<template><div><p class="d-docsite--paragraph">The hovercard will appear upon the mouse entering the anchor, with a delay of 300 milliseconds. It will remain open as long as the mouse cursor is over either the open card or the anchor.</p>
<code-example source-code='&lt;dt-hovercard placement=&quot;bottom-start&quot;&gt;
  &lt;template #anchor&gt;
    &lt;dt-button kind=&quot;muted&quot; importance=&quot;outlined&quot;&gt;
      Hover over me
    &lt;/dt-button&gt;
  &lt;/template&gt;
  &lt;template #content&gt;
    &lt;div&gt;Content&lt;/div&gt;
  &lt;/template&gt;
  &lt;template #headerContent&gt;
    &lt;div&gt;Header&lt;/div&gt;
  &lt;/template&gt;
  &lt;template #footerContent&gt;
    &lt;div&gt;Footer&lt;/div&gt;
  &lt;/template&gt;
&lt;/dt-hovercard&gt;'>
<example-hovercard />
</code-example>
<!-- <component-combinator component-name="DtHovercard" /> -->
<h2 id="variants" tabindex="-1" class="d-docsite--header-2">Variants <a class="header-anchor d-link d-docsite--link d-link" href="#variants" aria-hidden="true">#</a></h2>
<h3 id="many-hovercards" tabindex="-1" class="d-docsite--header-3">Many Hovercards <a class="header-anchor d-link d-docsite--link d-link" href="#many-hovercards" aria-hidden="true">#</a></h3>
<p class="d-docsite--paragraph">After opening one hovercard, moving to another skips the entrance delay — a &quot;warm-up&quot; pattern for faster navigation between targets.</p>
<code-example only-show="demo">
<dt-stack direction="row" gap="200">
  <example-hovercard v-for="data in exampleData" :label="data.label" :content="data.content" />
</dt-stack>
</code-example>
<h2 id="content-mode" tabindex="-1" class="d-docsite--header-2">Content Mode <a class="header-anchor d-link d-docsite--link d-link" href="#content-mode" aria-hidden="true">#</a></h2>
<p class="d-docsite--paragraph">Hovercard content renders outside the DOM tree. Use the <code v-pre>contentMode</code> prop to apply color mode (invert, light, dark) to the positioned content. See <a href="/components/mode-island.html#positioned-components" class="d-docsite--link d-link" target="_blank" rel="noopener noreferrer">Positioned Components</a> for details.</p>
<code-example source-code='&lt;dt-hovercard content-mode=&quot;invert&quot;&gt;...&lt;/dt-hovercard&gt;
&lt;dt-hovercard content-mode=&quot;dark&quot;&gt;...&lt;/dt-hovercard&gt;
&lt;dt-hovercard content-mode=&quot;light&quot;&gt;...&lt;/dt-hovercard&gt;'>
<dt-hovercard content-mode="invert" placement="bottom-start">
  <template #anchor>
    <dt-button :size="200" kind="muted" importance="outlined">Hover for Inverted Hovercard</dt-button>
  </template>
  <template #content>
    <dt-text as="p">This hovercard content is in the <dt-text strength="strong">inverted</dt-text> mode.</dt-text>
  </template>
</dt-hovercard>
</code-example>
<h2 id="vue-api" tabindex="-1" class="d-docsite--header-2">Vue API <a class="header-anchor d-link d-docsite--link d-link" href="#vue-api" aria-hidden="true">#</a></h2>
<component-vue-api component-name="hovercard" /></div></template>


<script setup>
  import ExampleHovercard from '@exampleComponents/ExampleHovercard.vue';

  const exampleData = [
    {
      label: 'Example 1',
      content: 'Content 1',
    },
    {
      label: 'Example 2',
      content: 'Content 2',
    },
    {
      label: 'Example 3',
      content: 'Content 3',
    },
  ];
</script>